export default "__VITE_ASSET__BbUAAj1h__"